import { ReactElement } from "react";
import { Link } from "react-router-dom";

import { TranslationService } from "../../services/TranslationService";
import SubmitButton from "./components/SubmitButton";
import Form from "./components/Form";
import { InfoMessage } from "./components/InfoMessage";
import { useLogonForm } from "./hooks/useLogonForm";

export { getRememberCacheValue } from "./hooks/useLogonForm";

function Logon(): ReactElement {
  const {
    formData,
    loading,
    visiblePassword,
    hasMessage,
    messageContent,
    handleLogIn,
    handleVisiblePassword,
    handleInputChange
  } = useLogonForm();
  const { translate, currentLanguage } = TranslationService;

  return (
    <>
      {hasMessage && <InfoMessage currentInfoMsg={messageContent} />}

      <Form back={false}>
        <h1>{translate.Login}</h1>

        <div className="input-group">
          <input
            type="email"
            placeholder={translate.Email}
            id="email"
            className="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          <i className="fas fa-user icono-input"></i>
        </div>

        <div className="input-group">
          <input
            type={visiblePassword ? "text" : "password"}
            id="password"
            name="password"
            className="contrasena"
            placeholder={translate.Password}
            onKeyPress={(e) => {
              if (e.key === "Enter") handleLogIn();
            }}
            value={formData.password}
            onChange={handleInputChange}
          />
          <i
            onClick={handleVisiblePassword}
            className={`fas fa-${visiblePassword ? "un" : ""}lock-alt icono-input`}
          />
        </div>

        <div className="pass">
          <Link to={`/${currentLanguage}/home/recoverpassword`}>
            {translate.PasswordForgotten}
          </Link>
        </div>

        <div className="recordar">
          <input
            type="checkbox"
            id="remember"
            name="remember"
            checked={formData.remember}
            onChange={handleInputChange}
          />
          <label htmlFor="remember">{translate.RememberMe}</label>
        </div>

        <div className="login-btn" id="loginbut">
          <SubmitButton
            onClick={handleLogIn}
            text={translate.Login.toUpperCase()}
            loading={loading}
          />
        </div>
      </Form>
    </>
  );
}

export default Logon;
